export default function validate(values) {
  let errors = {};

  if (!values.name) {
    errors.name = 'a product name is required';
  }
  
  if (!values.sku) {
    errors.sku = 'A product SKU is required';
  } 
  
  return errors;
};